
import { FC, useContext, useState } from "react";
import { GroupBase, OptionsOrGroups } from "react-select";
import { useForm, Controller } from "react-hook-form";
import Select from "react-select";
import { format, parse, } from "date-fns";
import DatePicker from "react-datepicker";
import ReactInputMask from "react-input-mask";
import { useDebouncedCallback } from "use-debounce";


import { reportFilterProps, ReportFilterState } from "./types";
import { DRUG_NAME } from "src/components/ActionDashBoardFilter/types";
import { AuthContext } from "src/context/authContext";
import { isZilrettaUser } from "src/helpers";




const ReportsFilter: FC<reportFilterProps> = ({ updateQueryParams, defaultQueryParams, doctorDropdown, practiceDropdown }): JSX.Element => {

    const [filteredDocListing, updatedFilteredDocListing] = useState<{ id: number; name: string; }[]>([])
    const [filteredPracticeListing, updatedFilteredPracticeListing] = useState<{ id: number; name: string; }[]>([])

    const { control, handleSubmit, reset, getValues, watch ,setValue} = useForm<ReportFilterState>({
        mode: 'all',
        defaultValues: defaultQueryParams,
    });
    const { userData } = useContext(AuthContext);
    

    setValue("drug_name",getValues('drug_name') === "All Product" || getValues('drug_name') === ""  ? DRUG_NAME[0].value : getValues('drug_name'))

    const start_date = watch("start_date");
    const end_date = watch("end_date");


    const searchForStats = (values: ReportFilterState) => {
        const updatedValues = {
            ...defaultQueryParams,
            ...values,
            practice_id:
                values.practice_id ?
                    (typeof values.practice_id === "string" ? values.practice_id : (values.practice_id as unknown as { value: string; label: string; }).value)
                    : "",
            drug_name:
                values.drug_name
                    ? (typeof values.drug_name === "string"
                        ? values.drug_name === "All Product"
                            ? ""
                            : values.drug_name
                        : (values.drug_name as { value: string; label: string }).value === "All Product"
                            ? ""
                            : (values.drug_name as { value: string; label: string }).value)
                    : "",
            global_doctor_id:
                values.global_doctor_id ?
                    (typeof values.global_doctor_id === "string" ? values.global_doctor_id : (values.global_doctor_id as unknown as { value: string; label: string; }).value)
                    : "",
        };

        updateQueryParams(updatedValues, false);
    };


    //:- Filtering practice from api recieved listing
    const filterPractice = (search: string) => {
        if (search.length >= 2) {
            updatedFilteredPracticeListing(
                practiceDropdown.filter((prac) => prac.name.toLowerCase().includes(search.toLowerCase()))
            )
        }
    };
    const debouncedFilterPractice = useDebouncedCallback(filterPractice, 500);

    //:- Filtereing doctor from api recieved listing
    const filterDoctor = (search: string) => {
        if (search.length >= 2) {
            updatedFilteredDocListing(
                doctorDropdown.filter((doc) => doc.name.toLowerCase().includes(search.toLowerCase()))
            )
        }
    };
    const debouncedFilterDoctor = useDebouncedCallback(filterDoctor, 500);


    const clearFormData = () => {
        const values = {
            ...defaultQueryParams,
            start_date: format((new Date()).setDate((new Date()).getDate() - 30), "yyyy-MM-dd"),
            end_date: format((new Date()).setDate((new Date()).getDate() + 1), "yyyy-MM-dd"),
            practice_id: "",
            global_doctor_id: "",
            //case_id: "",
            //global_patient_id: "",
            //patient_id: "",
           // doctor_name: "",
            drug_name: "",
            //global_patient_external_id:''


        };

        reset(values);
        updatedFilteredDocListing([]);
        updatedFilteredPracticeListing([]);
        updateQueryParams(getValues(), true);
    };

    return (
        <form className="filters row g-2" onSubmit={handleSubmit(searchForStats)}>
            <div className="col product-field mb-2">
                <Controller
                    name="drug_name"
                    control={control}
                    defaultValue={DRUG_NAME[0]?.value} // pehla option default
                    render={({ field }) => {
                        //console.log("drug_name field.value 👉", field.value);
                        return (
                            <Select
                                id="drug_name"
                                placeholder="Select Product"
                                isDisabled={isZilrettaUser(userData)}
                                options={
                                    DRUG_NAME.length > 0
                                        ? DRUG_NAME.map((item) => ({
                                            value: item.value,
                                            label: item.label,
                                        }))
                                        : []
                                }
                                value={
                                    field.value
                                        ? DRUG_NAME.find((item) => item.value === field.value)
                                        : null
                                }
                                onChange={(selectedOption) =>
                                    field.onChange(selectedOption ? selectedOption.value : "")
                                }
                                onBlur={field.onBlur}
                            />
                        );
                    }}
                />


            </div>
            <div className="col date-field mb-2">
                <Controller
                    name="start_date"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                        <DatePicker
                            selected={field.value.length > 0 ? parse(field.value, "yyyy-MM-dd", new Date()) : null}
                            onChange={(date) => date ? field.onChange(format(date, "yyyy-MM-dd")) : ""}
                            customInput={
                                <ReactInputMask mask="99/99/9999">{(inputProps: {}) =>
                                    <input {...inputProps} />}
                                </ReactInputMask>
                            }
                            className="form-control" wrapperClassName="w-100"
                            placeholderText="mm/dd/yyyy"
                            dateFormat="MM/dd/yyyy"
                            showMonthDropdown
                            showYearDropdown
                            maxDate={end_date ? new Date(end_date) : undefined}
                        />
                    )}
                />
            </div>
            <div className="col date-field mb-2">
                <Controller
                    name="end_date"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                        <DatePicker
                            selected={field.value.length > 0 ? parse(field.value, "yyyy-MM-dd", new Date()) : null}
                            onChange={(date) => date ? field.onChange(format(date, "yyyy-MM-dd")) : ""}
                            customInput={<ReactInputMask mask="99/99/9999">{(inputProps: {}) => <input {...inputProps} />}</ReactInputMask>}
                            className="form-control" wrapperClassName="w-100"
                            placeholderText="mm/dd/yyyy"
                            dateFormat="MM/dd/yyyy"
                            showMonthDropdown
                            showYearDropdown
                            minDate={start_date ? new Date(start_date) : undefined}
                        />
                    )}
                />
            </div>
            <div className="col mb-2">
                <Controller
                    name="practice_id"
                    control={control}
                    render={({ field }) => (
                        <Select
                            options={(filteredPracticeListing.length > 0 ?
                                filteredPracticeListing.map((item) => ({
                                    value: item.id.toString(),
                                    label: item.name
                                }))
                                : []
                            ) as unknown as OptionsOrGroups<string, GroupBase<string>>}
                            id="practice_id"
                            placeholder="Select Practice"
                            isSearchable={true}
                            {...field}
                            noOptionsMessage={() => "Please enter 2 or more characters to search..."}
                            onInputChange={debouncedFilterPractice}
                            onMenuClose={() => updatedFilteredPracticeListing([])}
                        />
                    )}
                />
            </div>
            <div className="col mb-2">
                <Controller
                    name="global_doctor_id"
                    control={control}
                    defaultValue={''}
                    render={({ field }) => (
                        <Select
                            options={(filteredDocListing.length > 0 ?
                                filteredDocListing.map((item) => ({ value: item.id, label: item.name }))
                                : []
                            ) as unknown as OptionsOrGroups<string, GroupBase<string>>}
                            id="global_doctor_id"
                            placeholder="Select Doctor"
                            isSearchable={true}
                            isClearable={true}
                            {...field}
                            noOptionsMessage={() => "Please enter 2 or more characters to search..."}
                            onInputChange={debouncedFilterDoctor}
                            onMenuClose={() => updatedFilteredDocListing([])}
                        />
                    )}
                />
            </div>
            {/* <div className="col mb-2">
                <Controller
                    name="global_doctor_id"
                    control={control}
                    defaultValue={''}
                    render={({ field }) => (
                        <Select
                            options={(filteredDocListing.length > 0 ?
                                filteredDocListing.map((item) => ({ value: item.id, label: item.name }))
                                : []
                            ) as unknown as OptionsOrGroups<string, GroupBase<string>>}
                            id="global_doctor_id"
                            placeholder="Select Doctor"
                            isSearchable={true}
                            isClearable={true}
                            {...field}
                            noOptionsMessage={() => "Please enter 2 or more characters to search..."}
                            onInputChange={debouncedFilterDoctor}
                            onMenuClose={() => updatedFilteredDocListing([])}
                        />
                    )}
                />
            </div> */}
            <div className="col btn-col mb-2">
                <div className="row g-2">
                    <div className="col-6">
                        <button type="submit" className="btn btn-primary w-100">Filter</button>
                    </div>
                    <div className="col-6">
                        <button type="button" onClick={clearFormData} className="btn btn-outline-secondary w-100">Clear</button>
                    </div>
                </div>
            </div>
        </form>
    );
};

export default ReportsFilter;
